import produce from 'immer'

import { FETCH_INDICES, FETCH_INDICES_SUCCESS, FETCH_INDICES_FAILURE } from '../actions/types'

export const initialIndexState = {
  id: null,
  docsDeleted: 0,
  documentCount: 0,
  health: null,
  name: null,
  status: null,
  storeSize: null,
}

export const initialState = {
  allIds: [],
  byId: {},
  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_INDICES: {
      draft.fetching = true
      break
    }
    case FETCH_INDICES_SUCCESS: {
      const indices = payload

      // Update async state flags
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      // Reset all indices
      draft.byId = {}
      draft.allIds = []

      // Add all indices to state
      for (const index of indices) {
        const id = index.name
        if (draft.allIds.indexOf(id) < 0) {
          draft.allIds.push(id)
        }

        draft.byId[id] = {
          ...index,
          id,
        }
      }

      break
    }
    case FETCH_INDICES_FAILURE: {
      const error = payload

      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }

    default:
      // Nothing to do
      break
  }
}, initialState)
